import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";
import Careers from "@/pages/Careers";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/components/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminJobs from "@/pages/admin/AdminJobs";
import AdminApplications from "@/pages/admin/AdminApplications";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminClients from "@/pages/admin/AdminClients";
import AdminInvoices from "@/pages/admin/AdminInvoices";
import AdminPreJoining from "@/pages/admin/AdminPreJoining";
import AdminEmailTemplates from "@/pages/admin/AdminEmailTemplates";
import AdminTraining from "@/pages/admin/AdminTraining";
import AdminInterviews from "@/pages/admin/AdminInterviews";
import PreJoiningLogin from "@/pages/prejoining/PreJoiningLogin";
import PreJoiningPortal from "@/pages/prejoining/PreJoiningPortal";
import TrainingLogin from "@/pages/training/TrainingLogin";
import TrainingPortal from "@/pages/training/TrainingPortal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route element={<Layout><Home /></Layout>} path="/" />
          <Route element={<Layout><About /></Layout>} path="/about" />
          <Route element={<Layout><Services /></Layout>} path="/services" />
          <Route element={<Layout><Contact /></Layout>} path="/contact" />
          <Route element={<Layout><Careers /></Layout>} path="/careers" />
          
          {/* Pre-Joining Portal Routes */}
          <Route path="/pre-joining/login" element={<PreJoiningLogin />} />
          <Route path="/pre-joining/portal" element={<PreJoiningPortal />} />
          
          {/* Training Portal Routes */}
          <Route path="/training/login" element={<TrainingLogin />} />
          <Route path="/training/portal" element={<TrainingPortal />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="analytics" element={<AdminAnalytics />} />
            <Route path="jobs" element={<AdminJobs />} />
            <Route path="applications" element={<AdminApplications />} />
            <Route path="interviews" element={<AdminInterviews />} />
            <Route path="contacts" element={<AdminContacts />} />
            <Route path="clients" element={<AdminClients />} />
            <Route path="invoices" element={<AdminInvoices />} />
            <Route path="pre-joining" element={<AdminPreJoining />} />
            <Route path="email-templates" element={<AdminEmailTemplates />} />
            <Route path="training" element={<AdminTraining />} />
            {/* Catch-all for invalid admin routes - redirect to admin login */}
            <Route path="*" element={<Navigate to="/admin/login" replace />} />
          </Route>
          
          {/* Catch-all for invalid routes - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
